module.exports = __webpack_public_path__ + "img/VetoSansCond-Italic.8fabdbef.svg";